import React from 'react';
import { InvestorFormData } from '@/utils/formValidation/investorForm';
import { PasswordField } from '../ui/PasswordField';
import { StateDropdown } from '../ui/StateDropdown';
import { TextField } from '../ui/TextField';
type CompanyInfoSectionProps = {
  formData: InvestorFormData;
  onFieldChange: (field: keyof InvestorFormData, value: string | boolean) => void;
  getFieldError: (field: keyof InvestorFormData) => string | undefined;
};

export const CompanyInfoSection: React.FC<CompanyInfoSectionProps> = ({ formData, onFieldChange, getFieldError }) => {
  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-base font-semibold text-gray-900 font-avenir">Company Info</h3>
      <div className="flex flex-col sm:flex-row w-full items-start justify-between gap-4 sm:gap-2">
        {/* Left Column */}
        <div className="flex h-full w-full sm:w-1/2 flex-col items-center justify-start gap-2 py-2">
          <div className="flex w-full flex-col items-start justify-start gap-2">
            {/* Company Name */}
            <TextField
              value={formData.companyName}
              onChange={(value) => onFieldChange('companyName', value)}
              placeholder="Company Name"
              error={!!getFieldError('companyName')}
            />

            {/* EIN */}
            <TextField
              value={formData.ein}
              onChange={(value) => onFieldChange('ein', value)}
              placeholder="EIN"
              error={!!getFieldError('ein')}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              helperText="Used for company verification and compliance"
            />

            {/* Address Line 1 */}
            <TextField
              value={formData.address1}
              onChange={(value) => onFieldChange('address1', value)}
              placeholder="Company Address Line 1"
              error={!!getFieldError('address1')}
            />

            {/* Address Line 2 */}
            <TextField
              value={formData.address2}
              onChange={(value) => onFieldChange('address2', value)}
              placeholder="Company Address Line 2"
              error={!!getFieldError('address2')}
            />
          </div>
        </div>

        {/* Right Column */}
        <div className="flex h-full w-full sm:w-1/2 flex-col items-center justify-start gap-2 py-2">
          <div className="flex w-full flex-col items-start justify-start gap-2">
            {/* City and State - Row 1 */}
            <div className="flex w-full gap-2 relative z-10">
              <TextField
                value={formData.city}
                onChange={(value) => onFieldChange('city', value)}
                placeholder="City"
                error={!!getFieldError('city')}
              />
              <div className="relative flex-shrink-0 w-[120px]">
                <StateDropdown
                  value={formData.state}
                  onChange={(value) => onFieldChange('state', value)}
                  placeholder="State"
                  error={!!getFieldError('state')}
                />
              </div>
            </div>

            {/* Zip and Country - Row 2 */}
            <div className="flex w-full gap-2">
              <TextField
                value={formData.zip}
                onChange={(value) => onFieldChange('zip', value)}
                placeholder="Zip Code"
                error={!!getFieldError('zip')}
              />
              <TextField value="United States" onChange={() => {}} placeholder="Country" size="small" disabled />
            </div>

            {/* Password */}
            <PasswordField
              value={formData.password}
              onChange={(value) => onFieldChange('password', value)}
              placeholder="Password"
              error={!!getFieldError('password')}
            />

            {/* Confirm Password */}
            <PasswordField
              value={formData.repeat}
              onChange={(value) => onFieldChange('repeat', value)}
              placeholder="Confirm Password"
              error={!!getFieldError('repeat')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
